interface ServiceCardProps {
  name: string;
  description: string;
  price: string;
  imageUrl: string;
  tags: string[];
  category: string;
}

const categoryMap: Record<string, string> = {
  consulting: '深夜咨询',
  delivery: '凌晨配送',
  support: '紧急支援',
  life: '生活服务',
  medical: '健康守护',
};

export default function ServiceCard({ name, description, price, imageUrl, tags, category }: ServiceCardProps) {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden group transition-all hover:border-primary-200/60">
      <div className="relative h-44 overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600 rounded-full">
          {categoryMap[category] || category}
        </span>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{name}</h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{description}</p>
        <div className="flex items-center flex-wrap gap-1.5 mb-3">
          {tags.map((tag) => (
            <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-primary-500 font-semibold text-sm">{price}</span>
          <a
            href="/about#contact"
            className="px-3 py-1.5 bg-primary-500 text-white rounded-lg text-xs font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            立即预约
          </a>
        </div>
      </div>
    </div>
  );
}